import React, {useEffect} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import FormGroup from "@mui/material/FormGroup";

import {setUserTwoFa} from "../../../../actions/userFunctions";
import {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {IS_PRODUCT_JOURNEY} from "../../../../config";
import TwoFaCodeInput, {sendAuthRequest} from "../../ui/twoFaCodeInput";

const LeadCapturePopupTwoFAVerify = (props) => {

  const {setUserTwoFa, userIsLoggedIn, userInfo, twoFALoading, closePopup} = props;

  useEffect(() => {
    const analyticsLabel = IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.leadCapturePopupTwoFAResendCode
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookLeadCapturePopupTwoFAResendCode;

    sendAuthRequest(twoFALoading, analyticsLabel, userInfo, userIsLoggedIn, 1, setUserTwoFa);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormGroup className="grohe-lead__form">
      <TwoFaCodeInput closePopup={closePopup}/>
    </FormGroup>
  )
};

LeadCapturePopupTwoFAVerify.propTypes = {
  closePopup: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const {userInfo, userIsLoggedIn, userTwoFa} = store.userState;
  const {twoFALoading} = userTwoFa;

  return {
    userInfo,
    userIsLoggedIn,
    twoFALoading,
  };
};

const mapDispatchToProps = {
  setUserTwoFa,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadCapturePopupTwoFAVerify)
